import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AppConstants } from 'src/app/shared/constants/app.contants';
import { PlanAccionPanelIotFormComponent } from './plan-accion-panel-iot-form/plan-accion-panel-iot-form.component';
import { MatDialog } from '@angular/material';
import { SensorTypeService } from 'src/app/services/sensor-type/sensor-type.service';
import { MessageModalComponent } from 'src/app/shared/components/modals/message/message-modal.component';
import { PanelIOTService } from 'src/app/services/panel-iot/panel-iot.service';

@Component({
  selector: 'app-plan-accion-panel-iot',
  templateUrl: './plan-accion-panel-iot.component.html',
  styleUrls: ['./plan-accion-panel-iot.component.css']
})
export class PlanAccionPanelIotComponent implements OnInit {

  @Input() sensor: any;
  @Input() type: string;
  @Output() goBack = new EventEmitter<void>();
  color1: string;
  color2: string;
  planList = [];
  sensorTypes = [];
  deviations = [];
  deviationCauses = [];
  deviationActionPlans = [];
  title = "";

  tiposDesviacion: string[] = ['Muy Alto', 'Alto', 'Moderado', 'Bajo', 'Muy Bajo'];
  tiposCausa: string[] = ['Falla eléctrica', 'Error humano', 'Condiciones ambientales'];
  planesAccion: string[] = ['Ajuste manual', 'Revisión técnica', 'Notificar supervisor'];

  selectedDesviacionId: number;
  selectedCausaId: number;
  selectedPlanId: number;

  constructor(
    private dialog: MatDialog,
    private sensorTypeService: SensorTypeService,
    private panelIOTService: PanelIOTService
  ) { }

  ngOnInit() {
    this.color1 = localStorage.getItem(AppConstants.Session.THEME_COLOR1);
    this.color2 = localStorage.getItem(AppConstants.Session.THEME_COLOR2);

    this.loadAlerts();
    this.title = " Poza "+ this.sensor.zone +" - Sensor " + this.sensor.sensor;
  }

  loadAlerts() {
    this.panelIOTService.getAlertBySensor(this.sensor.idSensor, this.type).subscribe(response => {
      if (response && response.data) {
        this.planList = response.data.map(alert => ({
          id: alert.id,
          idSensorType: this.sensor.idSensorType,
          poza: this.sensor.zone,
          hora: alert.createdAt,
          ctp: this.sensor.sensor,
          lectura: alert.value,
          actionPlanAt: alert.actionPlanAt,
          limites: `[${alert.minValue}, ${alert.maxValue}]`,
          valor: alert.valueActionPlan || '',
          descripcion: alert.descriptionActionPlan || '',
          selectedDesviacion: alert.idDeviation || null,
          selectedCausa: alert.idDeviationCause || null,
          selectedPlan: alert.idDeviationActionPlan || null,
          desviaciones: [],
          idDeviation: alert.idDeviation || 0,
          idDeviationCause: alert.idDeviationCause || 0,
          idDeviationActionPlan: alert.idDeviationActionPlan || 0,
          causas: [],
          planes: [],
          und: alert.undActionPlan || '',
          showCheck: alert.isEnabled == "1" ? true : false,
          isEnabled: alert.isEnabled
        }));

        // Load deviations for each alert
        this.planList.forEach(plan => {
          this.sensorTypeService.getListDeviation(this.sensor.idSensorType).subscribe(_ => {
            plan.desviaciones = _.data;

            // Si ya hay una desviación seleccionada, cargar causas y planes
            if (plan.selectedDesviacion) {
              this.sensorTypeService.getListDeviationCauses(plan.selectedDesviacion).subscribe(causas => {
                plan.causas = causas.data;
              });
              this.sensorTypeService.getListDeviationPlans(plan.selectedDesviacion).subscribe(planes => {
                plan.planes = planes.data;
              });
            }
          });
        });
        this.getEnabledPlansCount();
      }
    });
  }

  regresar() {
    this.goBack.emit();
  }

  onSensorChange(plan: any) {
    this.getListDeviation(plan.ctp, plan);
  }

  onPlanChange(id: number, plan: any) {
    this.selectedPlanId = id;
    if (this.selectedPlanId !== 0) {
      plan.descripcion = ''; // opcional: limpia si no es 'Otros'
    }
  }

  onCausaChange(id: number, plan: any) {
    this.selectedCausaId = id;
  }

  onDeviationSelect(id: number, plan: any) {
    this.selectedDesviacionId = id;
    this.getListDeviationCauses(id, plan);
    this.getListDeviationPlans(id, plan);
  }

  getSensorIdByCTP(ctp: string): number {
    switch (ctp.toLowerCase()) {
      case 'ph': return 9;
      case 'temperatura': return 5;
      case 'amoniaco':
      case 'amonio': return 6;
      default: return 0;
    }
  }

  getListDeviation(id: number, plan: any){
    this.sensorTypeService.getListDeviation(id).subscribe(_ => {
      plan.desviaciones = _.data;
    });
  }

  getListDeviationCauses(id: number, plan: any){
    this.sensorTypeService.getListDeviationCauses(id).subscribe(_ => {
      plan.causas = _.data;
    });
  }

  getListDeviationPlans(id: number, plan: any){
    this.sensorTypeService.getListDeviationPlans(id).subscribe(_ => {
      plan.planes = _.data;
    });
  }
  
  openPopup() {
    const dialogRef = this.dialog.open(MessageModalComponent, {
      data: {
        title: 'Confirmar plan de acción',
        message: '¿estás seguro de guardar los cambios?',
        hasButton: true,
        hasBackdrop: false,
        contentButton: {
          yes: 'SI',
          no: 'CANCELAR'
        }
      },
    });

    dialogRef.afterClosed().subscribe(response => {
      if (response) {
        this.saveActionPlans();
      }
    });
  }

  saveActionPlans() {
    const plansToSave = this.planList.filter(plan => plan.isEnabled === '1' );

    if (plansToSave.length === 0) {
      this.dialog.open(MessageModalComponent, {
        data: {
          title: 'Error',
          message: 'No hay planes de acción para guardar',
          hasButton: true,
          hasBackdrop: false,
          contentButton: {
            yes: 'OK',
            no: ''
          }
        },
      });
      return;
    }

    const payloads = plansToSave.map(plan => ({
      Id: plan.id,
      IdDeviation: this.selectedDesviacionId,
      IdDeviationCause: this.selectedCausaId,
      IdDeviationActionPlan: this.selectedPlanId,
      ValueActionPlan: plan.valor.toString(),
      UndActionPlan: plan.und,
      Description: plan.descripcion
    }));

    // Guardar cada plan de acción
    payloads.forEach(payload => {
      this.panelIOTService.updateAlertActionPlan(payload).subscribe(
        response => {
          if (!response.error) {
            this.loadAlerts(); // Recargar los datos después de guardar
          } else {
            this.dialog.open(MessageModalComponent, {
              data: {
                title: 'Error',
                message: 'Error al guardar el plan de acción',
                hasButton: true,
                hasBackdrop: false,
                contentButton: {
                  yes: 'OK',
                  no: ''
                }
              },
            });
          }
        },
        error => {
          this.dialog.open(MessageModalComponent, {
            data: {
              title: 'Error',
              message: 'Error al guardar el plan de acción',
              hasButton: true,
              hasBackdrop: false,
              contentButton: {
                yes: 'OK',
                no: ''
              }
            },
          });
        }
      );
    });
  }

  allowOnlyNumbers(event: KeyboardEvent) {
    const charCode = event.which ? event.which : event.keyCode;

    if (
      (charCode > 31 && (charCode < 48 || charCode > 57)) &&
      charCode !== 46
    ) {
      event.preventDefault();
    }
  }

  getEnabledPlansCount() {
    return this.planList.filter(plan => plan.isEnabled === '1' && plan.actionPlanAt == null).length;
  }
}
